import CopyFieldService from '~/services/CopyFieldService';
import EntriesMigrationService from '~/services/EntriesMigrationService';
import UpdateFieldService from '~/services/UpdateFieldService';

export interface IContentMigrationServices extends EntriesMigrationService {
  copy: CopyFieldService;
  update: UpdateFieldService;
}
